package anjuros.development.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateListOf
import anjuros.development.components.FAQCard
import anjuros.development.components.SectionTitle
import anjuros.development.modules.FAQ
import anjuros.development.modules.Section
import anjuros.development.util.Constants
import anjuros.development.util.FaqWidthStyle
import anjuros.development.util.SmallSectionWidthStyle
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px

@Composable
fun FAQSection(){
    Box(
        modifier = Modifier
            .id(Section.FAQ.id)
            .padding(top = 40.px)
            .maxWidth(Constants.SECTION_WIDTH.px),
        contentAlignment = Alignment.Center
    ) {
        FAQContent()

    }
}

@Composable
fun FAQContent(){


    var state = mutableStateListOf<Boolean>(false)


    repeat(FAQ.entries.size-1){
        state.add(false)
    }
    Column(
        modifier = Modifier.fillMaxSize()
        ,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SectionTitle(
            modifier = SmallSectionWidthStyle.toModifier()
                .margin(right = 50.px, bottom = 75.px),
            section = Section.FAQ,
            alignment = Alignment.CenterHorizontally
        )
        Column(
            modifier = FaqWidthStyle.toModifier(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            FAQ.entries.forEach { faq ->
                FAQCard(faq, state[faq.ordinal]) {
                    state[faq.ordinal] = !state[faq.ordinal]
                }

            }
        }
    }
}